export default __webpack_public_path__ + "static/media/uploader-animas-4.aacd1d2b.png";